import React from "react";
import { useQuery } from "@tanstack/react-query";
import { apiClient } from "zodios/client";
import HubspotTable from "modules/hubspot/HubspotTable";
import Loading from "components/core/blocks/Loading";
import { PageContainer } from "components/core/basic/PageContainer";
import Card from "components/core/basic/Card";
import type { HubspotTicket } from "zodios/apiDefinitions/api/tickets";

const FetchTickets: React.FC = () => {
  const {
    isPending,
    error,
    data: allTickets,
  } = useQuery<HubspotTicket[], Error>({
    queryKey: ["hubspotTickets"],
    queryFn: async () => await apiClient.getTickets(),
  });

  if (isPending) {
    return <Loading fullPage={false} height={300} />;
  }

  if (error) {
    return <div>Error fetching tickets: {error.message}</div>;
  }
  return (
    <PageContainer>
      <Card>
        <h3>Hubspot Tickets</h3>
        <HubspotTable tickets={allTickets} />
      </Card>
    </PageContainer>
  );
};

export default FetchTickets;
